export const translations = {
  en: {
    // Navigation
    nav: {
      home: "HOME",
      about: "ABOUT",
      services: "SERVICES",
      devices: "DEVICES",
      meetDoctor: "MEET OUR DOCTOR",
      doctor: "DOCTOR",
      contact: "CONTACT",
      bookNow: "BOOK NOW",
    },
    // Footer Quick Links
    footer: {
      quickLinks: {
        home: "Home",
        about: "About",
        doctor: "Doctor",
        services: "Services",
        devices: "Devices",
        contact: "Contact",
      },
    },
    // Booking / Schedule
    schedule: {
      name: "Name *",
      phone: "Phone *",
      preferredAt: "Preferred Date & Time *",
      selectDoctorService: "Select Doctor / Service *",
      select: "Select",
      message: "Message",
      placeholder: "Type here",
      submit: "SUBMIT",
      sending: "SENDING...",
      missingInfoTitle: "Missing information",
      missingInfoMsg: "Please fill all required fields.",
      bookingSentTitle: "Booking sent",
      bookingSentMsg: "We will contact you shortly.",
      failedTitle: "Submission failed",
      failedMsg: "Please try again later.",
    },
    // Contact Form
    contactForm: {
      name: "Name",
      phone: "Phone",
      email: "Email",
      message: "Message",
      submit: "Submit",
      sending: "Sending...",
      placeholder: "Type here",
      fillAll: "Please fill in all fields.",
      successMsg: "Your message has been sent successfully.",
      errorMsg: "Failed to send message. Please try again.",
    },
    // Patient Journey
    journey: {
      eyebrow: "Mandarin Clinic Experience",
      title: "Patient Journey - From First Contact to Results",
      subtitle:
        "The patient journey at Mandarin Clinic is structured around medical precision and premium comfort, with every stage designed for clarity, confidence, and measurable outcomes.",
      steps: [
        {
          step: "01",
          stage: "Consultation",
          details:
            "Comprehensive skin and goals discussion with Dr. Talal Rashid. Medical history reviewed. Treatment options recommended.",
        },
        {
          step: "02",
          stage: "VISIA Analysis",
          details:
            "Advanced 15-minute skin imaging reveals both visible and sub-surface conditions. Objective data informs the personalized treatment plan.",
        },
        {
          step: "03",
          stage: "Treatment Plan",
          details:
            "Dr. Rashid designs a customized protocol, selecting the right combination of technologies, session count, and spacing for optimal results.",
        },
        {
          step: "04",
          stage: "Treatment Session",
          details:
            "Patient is welcomed to an elegant, calm environment. Beverages offered. Treatment performed using advanced technology with full patient comfort focus.",
        },
        {
          step: "05",
          stage: "Aftercare",
          details:
            "Detailed aftercare instructions provided. Follow-up booking scheduled. Healing protocol guided by clinical team.",
        },
        {
          step: "06",
          stage: "Progress Review",
          details:
            "VISIA re-imaging at follow-up appointments tracks measurable improvement. Plan adjusted if needed. Results confirmed with objective imaging data.",
        },
      ],
    },
    // Services & Protocols
    protocols: {
      eyebrow: "Individual treatment protocols",
      protocolEyebrow: "PROTOCOL",
      machine: "Machine",
      sessions: "Sessions",
      time: "Time",
      treatmentTime: "Treatment Time",
      protocolOverview: "Protocol Overview",
      whatIsIncluded: "What Is Included",
      learnMore: "Learn more",
      whoCanBenefit: "Who Can Benefit",
      bestSuitedFor: "This protocol is best suited for:",
      whatIncludesHeading: "What This Service Includes",
      idealFor: "These treatments are ideal for individuals who want to",
    },
    // Doctors
    doctor: {
      specialty: "Specialty:",
      experience: "Experience:",
      approach: "Approach:",
      doctorNotFound: "Doctor not found",
      learnMore: "LEARN MORE",
    },
    // Devices
    devices: {
      ourTechnology: "OUR TECHNOLOGY",
      medicalDevices: "Medical\nDevices",
      equipmentAndPlatforms: "Equipment & platforms",
      equipmentDesc:
        "Select a device to read full clinical detail — technology, protocols, and how each system supports efficient results.",
      allEquipment: "All equipment",
      technology: "Technology",
      howItWorks: "How it works",
      sessions: "Sessions",
      treatmentTime: "Treatment time",
      conditionsTreated: "Conditions treated",
      keyBenefits: "Key benefits",
      whyFewerSessions:
        "Why this platform supports fewer sessions & strong results",
    },
    // 404 & Legal
    common: {
      pageNotFound: "Page not found",
      pageNotFoundDesc:
        "The page you are looking for doesn’t exist or has been moved.",
      goHome: "Go back home",
      lastUpdated: "Last updated:",
    },
  },
  ar: {
    // Navigation
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      services: "الخدمات",
      devices: "الأجهزة",
      meetDoctor: "طبيبنا",
      doctor: "الطبيب",
      contact: "تواصل معنا",
      bookNow: "احجز الآن",
    },
    // Footer Quick Links
    footer: {
      quickLinks: {
        home: "الرئيسية",
        about: "من نحن",
        doctor: "الطبيب",
        services: "الخدمات",
        devices: "الأجهزة",
        contact: "تواصل معنا",
      },
    },
    // Booking / Schedule
    schedule: {
      name: "الاسم *",
      phone: "رقم الهاتف *",
      preferredAt: "التاريخ والوقت المفضل *",
      selectDoctorService: "اختر الطبيب / الخدمة *",
      select: "اختر",
      message: "الرسالة",
      placeholder: "اكتب هنا",
      submit: "إرسال",
      sending: "جاري الإرسال...",
      missingInfoTitle: "معلومات ناقصة",
      missingInfoMsg: "يرجى ملء جميع الحقول المطلوبة.",
      bookingSentTitle: "تم إرسال الحجز",
      bookingSentMsg: "سنتواصل معك في أقرب وقت.",
      failedTitle: "فشل الإرسال",
      failedMsg: "يرجى المحاولة مرة أخرى لاحقاً.",
    },
    // Contact Form
    contactForm: {
      name: "الاسم",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      message: "الرسالة",
      submit: "إرسال",
      sending: "جاري الإرسال...",
      placeholder: "اكتب هنا",
      fillAll: "يرجى ملء جميع الحقول.",
      successMsg: "تم إرسال رسالتك بنجاح.",
      errorMsg: "فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.",
    },
    // Patient Journey
    journey: {
      eyebrow: "تجربة عيادة ماندريان",
      title: "رحلة المراجع - من التواصل الأول إلى النتائج",
      subtitle:
        "صُممت رحلة المراجع في عيادة ماندريان على أسس الدقة الطبية والراحة الفائقة، لتضمن لك الوضوح والثقة وأفضل النتائج الملموسة.",
      steps: [
        {
          step: "01",
          stage: "الاستشارة الطبية",
          details:
            "جلسة مفصلة لمناقشة أهدافك وفحص البشرة مع الدكتور طلال رشيد، مع مراجعة التاريخ الطبي واقتراح أنسب الحلول.",
        },
        {
          step: "02",
          stage: "تحليل فيزيا (VISIA)",
          details:
            "تصوير متقدم للبشرة خلال 15 دقيقة يكشف المشاكل السطحية والعميقة، لتقديم بيانات دقيقة لبناء خطة علاجية مخصصة.",
        },
        {
          step: "03",
          stage: "خطة العلاج",
          details:
            "يقوم الدكتور رشيد بوضع بروتوكول مخصص باختيار أحدث التقنيات وعدد الجلسات والفترات الفاصلة لتحقيق أفضل النتائج.",
        },
        {
          step: "04",
          stage: "جلسة العلاج",
          details:
            "استقبال المراجع في بيئة راقية ومريحة مع تقديم الضيافة، وإجراء العلاج بأحدث الأجهزة الطبية مع التركيز التام على راحتك.",
        },
        {
          step: "05",
          stage: "العناية اللاحقة",
          details:
            "تزويد المراجع بإرشادات دقيقة للعناية بعد العلاج، وجدولة موعد المتابعة بإشراف الفريق الطبي المختص.",
        },
        {
          step: "06",
          stage: "متابعة النتائج",
          details:
            "إعادة التصوير بجهاز فيزيا في مواعيد المتابعة لمراقبة التحسن وتأكيد النتائج بأحدث التقنيات الموضوعية.",
        },
      ],
    },
    // Services & Protocols
    protocols: {
      eyebrow: "بروتوكولات العلاج الفردية",
      protocolEyebrow: "بروتوكول",
      machine: "الجهاز",
      sessions: "الجلسات",
      time: "الوقت",
      treatmentTime: "مدة العلاج",
      protocolOverview: "نظرة عامة على البروتوكول",
      whatIsIncluded: "ما يتضمنه البروتوكول",
      learnMore: "المزيد من التفاصيل",
      whoCanBenefit: "من يمكنه الاستفادة",
      bestSuitedFor: "هذا البروتوكول هو الأنسب لـ:",
      whatIncludesHeading: "ما تتضمنه هذه الخدمة",
      idealFor: "هذه العلاجات مثالية للأشخاص الذين يرغبون في",
    },
    // Doctors
    doctor: {
      specialty: "التخصص:",
      experience: "الخبرة:",
      approach: "المنهجية:",
      doctorNotFound: "لم يتم العثور على الطبيب",
      learnMore: "اقرأ المزيد",
    },
    // Devices
    devices: {
      ourTechnology: "تقنياتنا",
      medicalDevices: "الأجهزة\nالطبية",
      equipmentAndPlatforms: "الأجهزة والتقنيات الطبية",
      equipmentDesc:
        "اختر جهازاً للاطلاع على التفاصيل السريرية الكاملة — التقنية، البروتوكولات، وكيف يضمن كل نظام أفضل النتائج.",
      allEquipment: "جميع الأجهزة",
      technology: "التقنية",
      howItWorks: "كيف يعمل الجهاز",
      sessions: "الجلسات",
      treatmentTime: "مدة العلاج",
      conditionsTreated: "الحالات المعالجة",
      keyBenefits: "الفوائد الرئيسية",
      whyFewerSessions:
        "لماذا تضمن هذه التقنية جلسات أقل ونتائج متميزة",
    },
    // 404 & Legal
    common: {
      pageNotFound: "الصفحة غير موجودة",
      pageNotFoundDesc:
        "الصفحة التي تبحث عنها غير موجودة أو ربما تم نقلها.",
      goHome: "العودة للرئيسية",
      lastUpdated: "آخر تحديث:",
    },
  },
  ku: {
    // Navigation
    nav: {
      home: "سەرەکی",
      about: "دەربارە",
      services: "خزمەتگوزارییەکان",
      devices: "ئامێرەکان",
      meetDoctor: "پزیشکەکەمان",
      doctor: "پزیشک",
      contact: "پەیوەندی",
      bookNow: "نۆرە بگرە",
    },
    // Footer Quick Links
    footer: {
      quickLinks: {
        home: "سەرەکی",
        about: "دەربارە",
        doctor: "پزیشک",
        services: "خزمەتگوزارییەکان",
        devices: "ئامێرەکان",
        contact: "پەیوەندی",
      },
    },
    // Booking / Schedule
    schedule: {
      name: "ناو *",
      phone: "ژمارەی مۆبایل *",
      preferredAt: "بەروار و کاتی پەسەندکراو *",
      selectDoctorService: "پزیشک / خزمەتگوزاری هەڵبژێرە *",
      select: "هەڵبژێرە",
      message: "پەیام",
      placeholder: "لێرە بنووسە",
      submit: "ناردن",
      sending: "دەنێردرێت...",
      missingInfoTitle: "زانیاری کەمە",
      missingInfoMsg: "تکایە هەموو خانە پێویستەکان پڕبکەرەوە.",
      bookingSentTitle: "نۆرەکەت تۆمارکرا",
      bookingSentMsg: "بە زووترین کات پەیوەندیت پێوە دەکەین.",
      failedTitle: "ناردن سەرکەوتوو نەبوو",
      failedMsg: "تکایە دواتر هەوڵ بدەرەوە.",
    },
    // Contact Form
    contactForm: {
      name: "ناو",
      phone: "مۆبایل",
      email: "ئیمەیڵ",
      message: "پەیام",
      submit: "ناردن",
      sending: "دەنێردرێت...",
      placeholder: "لێرە بنووسە",
      fillAll: "تکایە هەموو خانەکان پڕبکەرەوە.",
      successMsg: "پەیامەکەت بە سەرکەوتوویی نێردرا.",
      errorMsg: "ناردنی پەیام سەرکەوتوو نەبوو. تکایە دواتر هەوڵ بدەرەوە.",
    },
    // Patient Journey
    journey: {
      eyebrow: "ئەزموونی کلینیکی ماندەرین",
      title: "گەشتی نەخۆش - لە یەکەم پەیوەندییەوە تا ئەنجام",
      subtitle:
        "گەشتی نەخۆش لە کلینیکی ماندەرین لەسەر بنەمای وردبینی پزیشکی و ئاسوودەیی دابڕێژراوە، تا دڵنیایی و باشترین ئەنجامت پێ ببەخشێت.",
      steps: [
        {
          step: "01",
          stage: "ڕاوێژکاری پزیشکی",
          details:
            "دانیشتنێکی ورد بۆ دیاریکردنی ئامانجەکان و پشکنینی پێست لەگەڵ دکتۆر تەلال ڕەشید و پێداچوونەوە بە مێژووی پزیشکی.",
        },
        {
          step: "02",
          stage: "شیکاری ڤیزیا (VISIA)",
          details:
            "شیکاری پێشکەوتووی پێست بە 15 خولەک بۆ دەرخستنی نیشانە سەرەکی و ژێرپێستییەکان و داڕشتنی پلانی گونجاو.",
        },
        {
          step: "03",
          stage: "پلانی چارەسەر",
          details:
            "دکتۆر تەلال پڕۆتۆکۆڵێکی تایبەت دادەڕێژێت بە بەکارهێنانی گونجاوترین تەکنەلۆژیا و ژمارەی دانیشتنەکان بۆ باشترین ئەنجام.",
        },
        {
          step: "04",
          stage: "دانیشتنی چارەسەر",
          details:
            "پێشوازیکردن لە نەخۆش لە ژینگەیەکی ئارام و شایستە، ئەنجامدانی چارەسەر بە نوێترین ئامێرەکان بە تەواوی ئاسوودەییەوە.",
        },
        {
          step: "05",
          stage: "چاودێری دوای چارەسەر",
          details:
            "پێدانی ڕێنمایی ورد بۆ دوای چارەسەر و دیاریکردنی کاتی چاوپێکەوتنی دواتر لەژێر چاودێری تیمی پزیشکی.",
        },
        {
          step: "06",
          stage: "پێداچوونەوەی پێشکەوتن",
          details:
            "پشکنینەوەی دووبارە لە ڕێگەی ئامێری ڤیزیا بۆ بەدواداچوونی پێشکەوتن و دڵنیابوونەوە لە بەدەستهێنانی باشترین ئەنجام.",
        },
      ],
    },
    // Services & Protocols
    protocols: {
      eyebrow: "پڕۆتۆکۆڵە تایبەتەکانی چارەسەر",
      protocolEyebrow: "پڕۆتۆکۆڵ",
      machine: "ئامێر",
      sessions: "دانیشتنەکان",
      time: "کات",
      treatmentTime: "کاتی چارەسەر",
      protocolOverview: "کورتەی پڕۆتۆکۆڵ",
      whatIsIncluded: "چی لەخۆدەگرێت",
      learnMore: "زیاتر بزانە",
      whoCanBenefit: "کێ دەتوانێت سوودمەند بێت",
      bestSuitedFor: "ئەم پڕۆتۆکۆڵە گونجاوترینە بۆ:",
      whatIncludesHeading: "ئەم خزمەتگوزارییە چی لەخۆدەگرێت",
      idealFor: "ئەم چارەسەرانە گونجاون بۆ ئەو کەسانەی دەیانەوێت",
    },
    // Doctors
    doctor: {
      specialty: "پسپۆڕی:",
      experience: "ئەزموون:",
      approach: "شێوازی کارکردن:",
      doctorNotFound: "پزیشک نەدۆزرایەوە",
      learnMore: "زیاتر بزانە",
    },
    // Devices
    devices: {
      ourTechnology: "تەکنەلۆژیای ئێمە",
      medicalDevices: "ئامێرە\nپزیشکییەکان",
      equipmentAndPlatforms: "ئامێر و تەکنەلۆژیاکان",
      equipmentDesc:
        "ئامێرێک هەڵبژێرە بۆ بینینی وردەکارییە تەواوەکان — تەکنەلۆژیا، پڕۆتۆکۆڵەکان و چۆنیەتی بەدەستهێنانی باشترین ئەنجام.",
      allEquipment: "هەموو ئامێرەکان",
      technology: "تەکنەلۆژیا",
      howItWorks: "چۆن کاردەکات",
      sessions: "دانیشتنەکان",
      treatmentTime: "کاتی چارەسەر",
      conditionsTreated: "ئەو حاڵەتانەی چارەسەر دەکرێن",
      keyBenefits: "سوودە سەرەکییەکان",
      whyFewerSessions:
        "بۆچی ئەم تەکنەلۆژیایە پێویستی بە دانیشتنی کەمترە و ئەنجامی بەهێز دەدات",
    },
    // 404 & Legal
    common: {
      pageNotFound: "پەڕەکە نەدۆزرایەوە",
      pageNotFoundDesc:
        "ئەو پەڕەیەی بەدوایدا دەگەڕێیت بوونی نییە یاخود گوێزراوەتەوە.",
      goHome: "گەڕانەوە بۆ سەرەکی",
      lastUpdated: "دواین نوێکردنەوە:",
    },
  },
};

export const useT = (lang = "en") => {
  return translations[lang] || translations.en;
};
